<template>
  <div class="h-screen f-col">
    <customs-header :back-route="originalModel ? `/customize/${originalModel}` : '/customize'" />
    <main class="grow">
      <customs-toolkit :model @customs-product-added-to-cart="onAddToCart" />
    </main>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({ layout: false })

const { $gtm } = useNuxtApp()
const cart = useCartStore()
const { model } = useRoute().params
const { showMiniCartOnAddProduct } = useFeatureFlags()
const { DialogMiniCart } = useDialogsStore()

const { data, error } = await useApi().internal.getStaticPage('customs-models')
if (!data.value) throw createError({ ...error.value!, fatal: true })

const originalModel = Object.keys(data.value).find((category) => {
  const specificMatchedModel = data.value?.[category]
    ?.find((specificModel) => specificModel.to === `/customizer/${model}`)

  return !!specificMatchedModel
})

const onAddToCart = async () => {
  await cart.get()
  const productItem = cart.items.slice(-1)[0]
  setInteractionOrigin('customizer')
  setGtmCartProductsMap(
    productItem.productId,
    {
      id: productItem.productId,
      masterId: productItem.masterId,
      list: 'Customizer',
      breadcrumbs: [{ label: 'Customs' }],
      category: 'Customizer'
    }
  )
  $gtm.push(
    'cart.onAddToCart',
    cart,
    [productItem],
    { isCartItem: true }
  )
  $gtm.push('cart.onCartUpdate', cart)

  if (!showMiniCartOnAddProduct) return
  DialogMiniCart.open()
}
</script>
